import React from 'react';

const TermsConditions = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8 font-sans text-gray-800">
      <div className="max-w-4xl mx-auto bg-white p-8 sm:p-12 rounded-xl shadow-md border border-gray-100">
        
        {/* Header */}
        <div className="border-b-2 border-blue-600 pb-6 mb-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            TERMS & CONDITIONS
          </h1>
          <p className="text-sm text-gray-500 mt-2 italic">
            Sudeesha Solutions — Last Updated: July 02, 2026[cite: 1, 2]
          </p>
        </div>

        <p className="mb-6 leading-relaxed text-justify">
          Welcome to <strong className="text-slate-900">Sudeesha Solutions</strong> (accessible via <a href="https://sudeesha.com/" className="text-blue-600 hover:underline">https://sudeesha.com/</a>)[cite: 1, 2]. These Terms and Conditions govern the professional relationship between Sudeesha Solutions ("Company", "We", "Us") and our clients or website users ("Client", "You")[cite: 1]. By visiting our website or hiring us for our IT services, software development, web designing, mobile app development, or SEO services, you agree to comply with and be bound by these terms[cite: 1, 2].
        </p>

        {/* Section 1 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-blue-600 border-l-4 border-blue-600 pl-3 mb-4">
            1. Scope of Services
          </h2>
          <p className="mb-3 leading-relaxed">Sudeesha Solutions provides professional IT and software engineering consultancy across following deliverables[cite: 1, 2]:</p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li><strong>Web & Software Development:</strong> Building corporate websites, web applications, and backend APIs using .NET, React JS, and Angular[cite: 1, 2].</li>
            <li><strong>Mobile Application Development:</strong> Engineering cross-platform mobile apps for iOS and Android using the React Native framework[cite: 1, 2].</li>
            <li><strong>Database Management:</strong> Structuring, configuring, and optimizing relational and non-relational database models using SQL Server, PostgreSQL, and Firebase[cite: 1, 2].</li>
            <li><strong>UI/UX Designing:</strong> Digital user interface layout wireframes aur graphic asset planning[cite: 1, 2].</li>
            <li><strong>SEO & Hosting Operations:</strong> Providing Search Engine Optimization setups, domain management solutions, and web hosting deployments[cite: 1, 2].</li>
          </ul>
        </section>

        {/* Section 2 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-blue-600 border-l-4 border-blue-600 pl-3 mb-4">
            2. Client Responsibilities & Credentials
          </h2>
          <p className="mb-3 leading-relaxed text-justify">
            Project execution ke dauran, client ko mandatory business assets, functional briefs, aur material timely provide karna hoga[cite: 1, 2]. Agar project mein third-party solutions jaise ki <strong>Payment Gateways (Razorpay, Stripe, PayPal)</strong> required hain, toh unke official API sandbox aur live environment credentials secure tarike se client ko khud provide karne honge[cite: 1, 2].
          </p>
          <div className="bg-rose-50 border-l-4 border-rose-500 p-4 my-4 rounded-r-md">
            <p className="text-sm text-rose-800 font-medium">
              <strong>Security Warning:</strong> Sudeesha Solutions development phase ke baad client ko live credentials aur system access passwords rotate karne ki strong advice देती है[cite: 1, 2]. Handover ke baad kisi bhi unauthorized platform access ki responsibility hamari nahi hogi[cite: 1, 2].
            </p>
          </div>
        </section>

        {/* Section 3 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-blue-600 border-l-4 border-blue-600 pl-3 mb-4">
            3. Payment Terms & Third-Party Costs
          </h2>
          <p className="mb-3 leading-relaxed text-justify">
            Sudeesha Solutions aur client ke beech har project ke liye commercial scope aur milestones strictly separate agreement/quotation ke through fix kiye jaate hain[cite: 1, 2].
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
            <li>Kisi bhi project ko start karne ke liye advance deposit mandatory hai[cite: 1, 2].</li>
            <li>Milestone billing complete hone par client ko clear terms ke andar payments deliver karni hogi[cite: 1, 2].</li>
            <li><strong>Important Note:</strong> Kisi bhi third-party asset ki fees—jaise Domain purchasing, Cloud Web Hosting renewals, Premium API subscriptions, Play Store / App Store console developer accounts, aur Payment Gateway transaction charges—client ko directly un service providers ko pay karni hogi[cite: 1, 2].</li>
          </ul>
        </section>

        {/* Section 4 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-blue-600 border-l-4 border-blue-600 pl-3 mb-4">
            4. Intellectual Property & Source Code
          </h2>
          <p className="mb-3 leading-relaxed text-justify">
            Project completion aur final clear balance payments receive hone ke baad hi proprietary source code bases, operational databases, layout graphics, aur design assets ka entire digital ownership client ko handover kiya jata hai[cite: 1, 2]. Sudeesha Solutions final delivery tak un deliverables par complete code lien retain rakhne ka legal right rakhti hai[cite: 1, 2].
          </p>
        </section>

        {/* Section 5 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-blue-600 border-l-4 border-blue-600 pl-3 mb-4">
            5. Contact Us
          </h2>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 text-sm space-y-1">
            <p><strong className="text-slate-900">Company Name:</strong> Sudeesha Solutions[cite: 1, 2]</p>
            <p><strong className="text-slate-900">Website:</strong> <a href="https://sudeesha.com" className="text-blue-600 hover:underline">https://sudeesha.com/</a>[cite: 1, 2]</p>
            <p><strong className="text-slate-900">Email:</strong> <a href="mailto:sudeesha23@gmail.com" className="text-blue-600 hover:underline">sudeesha23@gmail.com</a>[cite: 1, 2]</p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default TermsConditions;